import React from 'react'
import Contact from '../Components/Contact/Contact'

function Contactpage() {
  return (
    <div>
      <Contact/>
    </div>
  )
}

export default Contactpage
